'use strict';
// Reuse Longvadon's original measuring illustrations; product sizing remains on the page.
// Robin, October 22: the guide ends with the store's size chart (wrist_size_table2.jpg on the Wrist Size Guide page),
// redrawn at the dialog's width so it stays readable on phones. Ranges in millimetres, read off that chart.
(()=>{
 const chart={min:108,max:256,ticks:[130,150,170,190,210,230,250],rows:[
  [{label:'S',from:150,to:190}],
  [{label:'Most women’s wrist',from:142,to:192,band:'women'}],
  [{label:'XS',from:130,to:160}],
  [{label:'Most men’s wrist',from:157,to:206,band:'men'}],
  [{label:'M',from:160,to:200},{label:'XL',from:205,to:240}]]};
 const at=mm=>((mm-chart.min)/(chart.max-chart.min)*100).toFixed(2)+'%',inches=mm=>(mm/25.4).toFixed(1);
 const span=(from,to)=>`left:${at(from)};width:${((to-from)/(chart.max-chart.min)*100).toFixed(2)}%`;
 // The 10 mm shaded columns start at every labelled tick, as on the original chart.
 const stripes=[];for(let mm=110;mm<chart.max;mm+=20){const from=Math.max(mm,chart.min),to=Math.min(mm+10,chart.max);if(to>from)stripes.push(`<i style="${span(from,to)}"></i>`)}
 const bar=(b,row)=>`<li class="wrist-chart-bar${b.band?' wrist-chart-band wrist-chart-'+b.band:''}" style="grid-row:${row};margin-left:${at(b.from)};width:${((b.to-b.from)/(chart.max-chart.min)*100).toFixed(2)}%"><span aria-hidden="true">${b.label}</span><span class="wrist-chart-sr">${b.label}: ${b.band?'about ':''}${b.from}–${b.to} mm (${inches(b.from)}–${inches(b.to)} in)</span></li>`;
 const chartMarkup=()=>`
  <figure class="wrist-help-chart">
   <figcaption><strong>Find your size</strong><span>Find your measurement on the scale. The gold bar below it is your size.</span></figcaption>
   <div class="wrist-chart">
    <div class="wrist-chart-scale" aria-hidden="true">
     <p><span class="wrist-chart-unit">in</span>${chart.ticks.map(mm=>`<span style="left:${at(mm)}">${inches(mm)}</span>`).join('')}</p>
     <p><span class="wrist-chart-unit">mm</span>${chart.ticks.map(mm=>`<span style="left:${at(mm)}">${mm}</span>`).join('')}</p>
    </div>
    <div class="wrist-chart-ticks" aria-hidden="true">${chart.ticks.map(mm=>`<i style="left:${at(mm)}"></i>`).join('')}</div>
    <div class="wrist-chart-plot">
     <div class="wrist-chart-stripes" aria-hidden="true">${stripes.join('')}</div>
     <ul class="wrist-chart-bars" aria-label="Wrist sizes by wrist measurement">${chart.rows.flatMap((row,i)=>row.map(b=>bar(b,i+1))).join('')}</ul>
    </div>
   </div>
  </figure>`;
 window.LongvadonWristHelp={markup:()=>`
 <div class="wrist-help-intro"><p>Use a piece of string and a ruler.</p></div>
 <div class="wrist-help-body">
  <figure class="wrist-help-wrap">
   <figcaption><strong>Wrap & mark</strong><span>Mark where the ends meet.</span></figcaption>
   <img src="https://cdn.shopify.com/s/files/1/2721/8906/files/wrist_measuring1.png?v=1724935163" width="600" height="612" alt="A string wrapped around the wrist, with the point where the ends meet held between two fingers.">
   <p>Leave a pinky-tip gap for comfort.</p>
  </figure>
  <figure class="wrist-help-measure">
   <figcaption><strong>Lay flat & measure</strong><span>The marked length is your wrist measurement.</span></figcaption>
   <img src="https://cdn.shopify.com/s/files/1/2721/8906/files/wrist_measuring2.png?v=1724935163" width="897" height="361" alt="The marked string laid flat alongside a ruler to measure its length.">
  </figure>${chartMarkup()}
 </div>`};
})();
